import clsx from "clsx";
import { useApiQuery } from "@/api/hooks";
import { useParams } from "react-router-dom";
import {
    CompanyConnector,
    getCompanyConnectors,
    PlatformType,
} from "@/entities/Company";
import { selectedPlatformTypeAtom } from "../connectors.state";
import { useAtom } from "jotai";
import { PLATFORM_TYPE_LABELS } from "../connectors.types";

export const ConnectorList = () => {
    const { companyId } = useParams();
    const { data: connectors, isLoading } = useApiQuery(getCompanyConnectors, {
        params: { uuid: companyId },
    });
    const [selectedPlatformType, setSelectedPlatformType] = useAtom(
        selectedPlatformTypeAtom,
    );

    const selectedConnectorId = "1";

    if (isLoading)
        return (
            <>
                {[...Array(10)].map((_, i) => (
                    <div
                        key={i}
                        className={clsx(
                            "bg-selected h-20 w-full animate-pulse self-center rounded",
                        )}
                    />
                ))}
            </>
        );

    return (
        <div
            className={clsx(
                "mt-4 h-full",
                "flex flex-col",
                "min-h-0 overflow-hidden",
            )}
        >
            <div className="mb-4 flex justify-between">
                <ul
                    className={clsx(
                        "w-full p-1",
                        "lozenge flex justify-between gap-2",
                    )}
                >
                    {Object.values(PlatformType)
                        .sort()
                        .map((platformType) => (
                            <li
                                key={platformType}
                                className={clsx(
                                    "cursor-pointer rounded p-2 px-2.5",
                                    "hover:bg-hover",
                                    selectedPlatformType === platformType &&
                                        "bg-selected",
                                )}
                                onClick={() => {
                                    setSelectedPlatformType(platformType);
                                }}
                            >
                                {PLATFORM_TYPE_LABELS[platformType]}
                            </li>
                        ))}
                </ul>
            </div>

            <ul
                className={clsx(
                    "flex flex-1 flex-col",
                    "hide-scrollbar min-h-0 gap-2 overflow-y-auto",
                )}
            >
                {connectors
                    ?.filter(
                        (connector: CompanyConnector) =>
                            !!connector.config &&
                            connector.config.platformType ===
                                selectedPlatformType,
                    )
                    .map((connector: CompanyConnector) => (
                        <li
                            className={clsx(
                                "card flex flex-col gap-2",
                                selectedConnectorId ===
                                    connector.config?.uuid && "selected",
                            )}
                            key={connector.config?.uuid}
                            onClick={() => {
                                // router.navigate(
                                //     `/beta/companies/${router.params.companyId}/labeling/files/${file.id}`,
                                // );
                            }}
                        >
                            <div className="subdued">
                                <div className="flex cursor-pointer flex-col gap-2">
                                    <p className="body-s cursor-pointer break-all pr-1">
                                        {connector.connectorType}
                                    </p>
                                    <p>{connector.config?.uuid}</p>
                                </div>
                            </div>
                        </li>
                    ))}
            </ul>
        </div>
    );
};
